import BaseModel from 'src/model/base.model';

class ProductManufacturer extends BaseModel {
  public manufacturerCode: string;
  public manufacturerName: string;
  public productNumber: string;
}

export default ProductManufacturer;
